import { Target, Eye, Zap, Users } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollReveal from "@/components/ScrollReveal";

const team = [
  { name: "Lorenz Wieschemann", role: "Inhaber", initials: "LW", email: "Wieschemann@4facemedia.de" },
  { name: "Steven Thiele", role: "Creativ Director ", initials: "ST", email: "Thiele@4facemedia.de" },
  { name: "Nick Patzak ", role: "Art Director ", initials: "NP", email: "Patzak@4facemedia.de" },
  { name: "Arthur Wiggerhaus", role: "​Videograph & Cutter", initials: "AW" },
  { name: "Finn Markert", role: "Fotograph", initials: "FM" },
  { name: "LOUIS MATZMOHR", role: "Webentwicklung", initials: "LM" },
  { name: "Neues Mitglied", role: "Bewirb dich! ", initials: "NM" },
];

const values = [
  { icon: Target, title: "Zielgerichtet", text: "Jedes Projekt verfolgt ein klares Ziel messbar, greifbar, erfolgreich." },
  { icon: Eye, title: "Detailverliebt", text: "Vom Pixel bis zum Storyline wir achten auf jedes Detail." },
  { icon: Zap, title: "Innovativ", text: "Wir nutzen die neuesten Tools und Trends für zeitgemäße Ergebnisse." },
  { icon: Users, title: "Partnerschaftlich", text: "Wir arbeiten mit euch, nicht nur für euch als echte Partner." },
];

const UeberUns = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <section className="pt-32 pb-20 bg-gradient-hero">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <span className="text-primary text-sm font-medium tracking-wider uppercase">Wer wir sind</span>
            <h1 className="text-5xl md:text-7xl font-bold text-foreground mt-4 mb-6">
              Über <span className="text-gradient">4FACEMEDIA</span>
            </h1>
            <p className="text-xl text-foreground/85 max-w-2xl">
              Kreativität, Strategie und Leidenschaft das sind die drei Säulen, auf denen wir alles aufbauen.
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* Story */}
      <section className="py-28">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <ScrollReveal>
              <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                Unsere <span className="text-gradient">Geschichte</span>
              </h2>
              <div className="space-y-4 text-foreground/85 leading-relaxed">
                <p>
                  4FACEMEDIA entstand aus der Überzeugung, dass großartige Marken mehr brauchen als nur ein hübsches Logo. Sie brauchen eine Geschichte, eine digitale Präsenz, visuelle Inhalte und eine Stimme in den sozialen Medien.
                </p>
                <p>
                  Deshalb haben wir unser 360°-Modell entwickelt: Ein Team, vier Disziplinen, ein nahtloses Ergebnis. Vom Motorsport-Video über den E-Commerce-Shop bis zur Instagram-Kampagne alles kommt aus einer Hand.
                </p>
                <p>
                  Unser Antrieb? Die Begeisterung unserer Kunden, wenn sie sehen, wie ihre Vision zum Leben erwacht.
                </p>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <div className="grid grid-cols-2 gap-4">
                {[
                  { number: "70+", label: "Abgeschlossene Projekte" },
                  { number: "50+", label: "Zufriedene Kunden" },
                  { number: "3+", label: "Jahre Erfahrung" },
                  { number: "4", label: "Kernbereiche" },
                ].map((stat) => (
                  <div key={stat.label} className="p-8 rounded-2xl bg-gradient-card border border-border/50 text-center">
                    <div className="text-3xl font-bold text-gradient mb-2">{stat.number}</div>
                    <div className="text-sm text-foreground/85">{stat.label}</div>
                  </div>
                ))}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-28 bg-card/30">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <div className="text-center mb-16">
              <span className="text-primary text-sm font-medium tracking-wider uppercase">Unsere Werte</span>
              <h2 className="text-4xl md:text-5xl font-bold text-foreground mt-4">
                Wofür wir <span className="text-gradient">stehen</span>
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, i) => (
              <ScrollReveal key={value.title} delay={i * 100}>
                <div className="p-8 rounded-2xl bg-gradient-card border border-border/50 text-center h-full">
                  <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mx-auto mb-5">
                    <value.icon size={26} className="text-primary" />
                  </div>
                  <h3 className="text-lg font-semibold text-foreground mb-3">{value.title}</h3>
                  <p className="text-sm text-foreground/85 leading-relaxed">{value.text}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-28">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <div className="text-center mb-16">
              <span className="text-primary text-sm font-medium tracking-wider uppercase">Das Team</span>
              <h2 className="text-4xl md:text-5xl font-bold text-foreground mt-4">
                Die <span className="text-gradient">Köpfe</span> dahinter
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {team.map((member, i) => (
              <ScrollReveal key={member.name} delay={i * 100}>
                <div className="p-8 rounded-2xl bg-gradient-card border border-border/50 text-center group hover:border-primary/30 transition-all duration-300">
                  <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-6 text-2xl font-bold text-primary group-hover:bg-primary/20 transition-colors">
                    {member.initials}
                  </div>
                  <h3 className="text-lg font-semibold text-foreground">{member.name}</h3>
                  <p className="text-sm text-foreground/85 mt-1">{member.role}</p>
                  {member.email && (
                    <a href={`mailto:${member.email}`} className="text-primary hover:text-primary/80 mt-2 block transition-colors text-xs break-all">
                      {member.email}
                    </a>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default UeberUns;
